module.exports = __webpack_public_path__ + "static/fox-portal-9082a29208f1959dd8ea699dc6f13237.jpg";